import { MemberOverviewTab } from "@/components/members/detail/member-overview-tab.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/settings/org/members/$userId/",
)({
	component: MemberOverviewTab,
});
